/**
 * Character Counter Plugin
 * @description Given a limit, displays characters left for a text input in UI
 */
var CharCounter = function(element, options){
    this.element = element;
    this.$element = $(element);
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};

CharCounter.prototype = {
    // shorthand for using prototype
    constructor : CharCounter,

    defaults: {
        charlimit: 70,
        enforcelimit: true,
        inputSelector: '.js-char-input',
        outputSelector: '.js-char-output'
    },

    handleTextInput: function() {
        var _this = this;

        var limit = _this.settings.charlimit;
        var currentcount = _this.$element.find(_this.settings.inputSelector).val().length;
        var charleft = limit - currentcount;
        _this.$element.find(_this.settings.outputSelector).html(charleft);
    },

    bind: function() {
        var _this = this;

        _this.$element.on('focus keyup', _this.settings.inputSelector, _this.handleTextInput.bind(_this));
    },

    unbind: function() {
        var _this = this;

        _this.$element.off('focus keyup', _this.settings.inputSelector, _this.handleTextInput.bind(_this));
    },

    init: function() {
        var _this = this;

        if (_this.settings.enforcelimit) {
            _this.$element.find(_this.settings.inputSelector).attr('maxlength', _this.settings.charlimit);
        }

        _this.bind();
        _this.handleTextInput()
    },

    destroy: function() {
        var _this = this;

        if (_this.settings.enforcelimit) {
            _this.$element.find(_this.settings.inputSelector).removeAttr('maxlength');
        }

        _this.unbind();
        _this.removeData('qg_char_counter');
    }
};

$.fn.charCounter = function ( options ) {
    this.each(function() {
        if ( !$.data( this, "qg_char_counter" ) ) {
            $.data( this, "qg_char_counter", new CharCounter( this, options ) );
        }
    });

    // chain jQuery functions
    return this;
};